import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
import { Notice } from '@/components/kit';
import { useKeyboardInset, useOnline } from '@/lib/hooks';
import { BookingSheet } from '@/features/booking/BookingSheet';
import { AssistantSheet } from '@/features/assistant/AssistantSheet';
import { BottomNav } from './BottomNav';
import { StickyBook } from './StickyBook';

/** Customer-facing frame: content, glass bottom navigation, booking and assistant sheets. */
export function ClientLayout() {
  const online = useOnline();
  const location = useLocation();
  useKeyboardInset();

  // New page → start at the top (the booking sheet only changes the query string).
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [location.pathname]);

  return (
    <>
      <a href="#main" className="visually-hidden">
        Перейти к содержимому
      </a>
      <main id="main" className="app-page" tabIndex={-1}>
        {!online ? (
          <div className="ui-page" style={{ paddingBottom: 0 }}>
            <Notice title="Нет соединения">Показаны сохранённые данные. Записаться можно, когда связь появится.</Notice>
          </div>
        ) : null}
        <Outlet />
      </main>
      <StickyBook />
      <BottomNav />
      <BookingSheet />
      <AssistantSheet />
    </>
  );
}
